import { Box, Typography, useMediaQuery } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { theme } from "../../../../utils/Theme";

const isEmpty = (v) => [null, undefined, "", "null"].includes(v);

function StatBox({ label, value, unit }) {
  const empty = isEmpty(value);
  return (
    <Box
      sx={{
        p: '7px 10px',
        borderRadius: '8px',
        backgroundColor: empty ? '#f9fafb' : '#ebf4fb',
        border: `1px solid ${empty ? '#f3f4f6' : '#aed6f1'}`,
        flex: 1,
        minWidth: 64,
      }}
    >
      <Typography sx={{ fontSize: '0.58rem', fontWeight: 700, color: '#9ca3af', letterSpacing: '0.07em', textTransform: 'uppercase', mb: 0.25, lineHeight: 1.2 }}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '3px' }}>
        <Typography sx={{ fontSize: '0.84rem', fontWeight: 700, color: empty ? '#d1d5db' : '#02357a', lineHeight: 1.3 }}>
          {empty ? '—' : value}
        </Typography>
        {!empty && unit && (
          <Typography sx={{ fontSize: '0.56rem', color: '#1a7ac4', fontWeight: 600, letterSpacing: '0.04em' }}>{unit}</Typography>
        )}
      </Box>
    </Box>
  );
}

function StatGroup({ title, children }) {
  return (
    <Box sx={{ mb: 1.5, '&:last-child': { mb: 0 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.75 }}>
        <Box sx={{ width: 3, height: 11, borderRadius: 2, background: 'linear-gradient(180deg, #03407b, #02357a)', flexShrink: 0 }} />
        <Typography sx={{ fontSize: '0.61rem', fontWeight: 700, color: '#03407b', letterSpacing: '0.09em', textTransform: 'uppercase' }}>
          {title}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
        {children}
      </Box>
    </Box>
  );
}

export default function PostRecherche({
  actuellePackage,
  actuelleFixe,
  actuelleVariable,
  actuelleInteressement,
  actuelleAutres,
  souhaiteAutres,
  souhaiteTjm,
  souhaiteFixe,
  souhaiteInteressement,
  souhaitePackage,
  souhaiteVariable,
  dispoLe,
  preAvis,
}) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isTalentManager, setIsTalentManager] = useState(false);
  const [isCheckAcquManager, setIsCheckAcquManager] = useState(false);

  function getUserData() {
    return JSON.parse(localStorage.getItem("userData"));
  }

  useEffect(() => {
    const role = getUserData()?.role || [];
    setIsAdmin(role.includes('ROLE_DIRECTION'));
    setIsTalentManager(role.includes('ROLE_TALENT_MANAGER'));
    setIsCheckAcquManager(role.includes('ROLE_TALENT_ACQUISITION_MANAGER'));
  }, []);

  const showSalary = isAdmin || isTalentManager || isCheckAcquManager;
  const dispoLeFormatted = !isEmpty(dispoLe) ? moment(dispoLe).format("DD/MM/YYYY") : null;

  return (
    <Box>
      <StatGroup title="Disponibilité">
        <StatBox label="Préavis" value={preAvis} />
        <StatBox label="Dispo le" value={dispoLeFormatted} />
      </StatGroup>

      {showSalary && (
        <>
          <StatGroup title="Net mensuel actuel">
            <StatBox label="Package" value={actuellePackage} unit="MAD" />
            <StatBox label="Fixe" value={actuelleFixe} unit="MAD" />
            <StatBox label="Variable" value={actuelleVariable} unit="MAD" />
            <StatBox label="TJM" value={souhaiteTjm} unit="MAD" />
          </StatGroup>

          <StatGroup title="Net mensuel souhaité">
            <StatBox label="Package" value={souhaitePackage} unit="MAD" />
            <StatBox label="Fixe" value={souhaiteFixe} unit="MAD" />
            <StatBox label="Variable" value={souhaiteVariable} unit="MAD" />
          </StatGroup>
        </>
      )}
    </Box>
  );
}
